import api from '@/api'
import { ContactsStoredType } from '../types/enums'

export default {
    
    /**
     * 그룹연락처 구성원을 조회합니다.
     * @param item 그룹연락처
     * @param type database/exchange 구분
     */
    getGroupMembers(item: contacts.ContactItem, type: ContactsStoredType): Promise<PagedItemList<contacts.ContactItem>>{
        var id = `${item.id}`;
        return api.post({
            url: '/api/contact/groupcontact/list?type=' + type,
            data:{
                parentId: id
            }
        });
    },

    /**
     * 그룹연락처를 생성합니다.
     * @param item 그룹연락처
     * @param type database/exchange 구분
     */
    createGroupContact(item: contacts.ContactItem, type: ContactsStoredType): Promise<string>{
        return api.post({
            url: '/api/contact/groupcontact/create?type=' + type,
            data: {
                fields: [
                    { key: 'DisplayName', 'value': item.displayName }
                ],
                parentId: item.parentFolderId,
                type: 'ContactGroup'
            }
        });
    },

    /**
     * 그룹연락처 구성원을 추가합니다.
     * @param ids 연락처 ID 배열
     * @param groupId 그룹연락처 ID
     * @param type database/exchange 구분
     */
    setGroupMember(ids: Array<string>, groupId: string, type: ContactsStoredType): Promise<boolean>{
        return api.post({
            url: `/api/contact/groupcontact/set?type=${type}&groupId=${groupId}`,
            data: ids
        });
    },

    /**
     * 그룹연락처 구성원을 삭제합니다.
     * @param ids 연락처 ID 배열
     * @param groupId 그룹연락처 ID
     * @param type database/exchange 구분
     */
    deleteGroupMember(ids: Array<string>, groupId: string, type: ContactsStoredType): Promise<boolean>{
        return api.delete({
            url: `/api/contact/groupcontact?type=${type}&groupId=${groupId}`,
            data: ids
        });
    } 
}